export const getSubcontractorInitialValues = () => {
  return { email: '', comment: '' }
}
